import * as React from 'react';

class TableCellwithColors extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <td className="text-center">
                <div
                    style={{
                        display: 'inline-block',
                        background: this.props.color,
                        borderRadius: '50%',
                        width: '17px',
                        height: '17px',
                        // margin: '5px 8px 0px 0',
                        textAlign: 'center',
                    }}>
                </div>
            </td>
        );
    }
}
export default TableCellwithColors;


// WEBPACK FOOTER //
// ./src/sharedcomponents/TableCellwithColors.tsx